import Dropdown from "../../common/components/fundamentals/Dropdown";
import { useAlqemiArchiveDashboard } from "../context/AlqemiArchiveDashboardProvider";

export default function ArchiveCandidateFilterDropdown({
  candidates,
  setPageNum,
  saveFilterName,
}: {
  candidates: any[];
  setPageNum: (pageNum: number) => void;
  saveFilterName?: string;
}) {
  const { currentFilters, addAlqemiFilter, removeAlqemiFilter } =
    useAlqemiArchiveDashboard();
  const options = [
    { value: "All candidates" },
    ...candidates.map((candidate) => ({
      value: candidate.consultant_id,
      name: candidate.name,
    })),
  ];

  const initialSelected = currentFilters.find(
    (filter) => filter.field === "currentCandidate"
  )?.value;

  return (
    <Dropdown
      id="table-filters"
      options={options}
      initialSelected={initialSelected ? initialSelected : "All candidates"}
      onChange={async (value) => {
        if (value === "All candidates") {
          removeAlqemiFilter("currentCandidate");
          if (saveFilterName) {
            localStorage.removeItem(saveFilterName);
          }
          setPageNum(1);
        } else {
          addAlqemiFilter({
            field: "currentCandidate",
            value: value,
          });
          if (saveFilterName) {
            localStorage.setItem(saveFilterName, value);
          }
          setPageNum(1);
        }
      }}
    />
  );
}